import paymentMethod from "./paymentMethod.json";
export default paymentMethod;
